import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageContainer from "../Layout/PageContainer";
import RefundView from "./View";
import refundService from "../../redux/services/refund.service";

export default function RefundDetailsView() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [refundDetail, setRefundDetail] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!id || !/\d+/.test(id)) {
            navigate(-1);
            return;
        }

        const fetchRefundDetails = async () => {
            try {
                const response = await refundService.getRefundDetails(id);
                if (response && response.data && response.data.data) {
                    setRefundDetail(response.data.data);
                } else {
                    toast.error("Unable to find refund details.");
                    navigate(-1);
                }
            } catch (error) {
                console.error("Error fetching refund details:", error);
                toast.error(error?.response?.data?.message || "Failed to fetch refund details.");
                navigate(-1);
            } finally {
                setLoading(false);
            }
        };

        fetchRefundDetails();
    }, [id, navigate]);

    return (
        <PageContainer
            pageTitleIcon="pe-7s-shopbag icon-gradient bg-plum-plate"
            pageHeading="Refund Details"
            pageSubTitle="Detailed view of the refund and reservation information."
        >
            {loading ? (
                <div>Loading...</div>
            ) : (
                <RefundView refundDetail={refundDetail} />
            )}
        </PageContainer>
    );
}
